<!--template的内容-->
<template>
    <div class="toast">
        <slot>{{message}}</slot>
    </div>
</template>

<script>
    export default {
        name: 'toast',
        data() {
            return {
                duration: 1500, //默认toast消失的时间
                message: '', //toast显示的内容
            }
        },
        mounted() {
            setTimeout(() => {
                if(this.$el.innerText.length>10){
                    setTimeout(() => {
                        this.$destroy(true);
                        this.$el.parentNode.removeChild(this.$el);
                    }, this.duration)
                }else{
                    this.$destroy(true);
                    this.$el.parentNode.removeChild(this.$el);
                }
            }, this.duration)
        }
    }
</script>

<style scoped>
    .toast {
        max-width: 80%;
        padding: 10px 20px;
        position: fixed;
		z-index: 1145367890;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #000000;
        border-radius: 6px;
        line-height: 24px;
        font-size: 16px;
        text-align: center;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/toast/toast.vue